import Wxapp from '../service/wxapp'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    createpreauthcode(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Wxapp.createpreauthcode(payload), {
        type: 'info',
        success,
        fail
      })
    }
  }
}
